// Merkan · Logo aus den Original-Dateien (DS-03). Der Name erscheint nie als Live-Text,
// sondern immer als Lockup-Datei. Auf dunklem Grund (Dunkelmodus) die inverse Fassung.
import lockup from '../assets/marke/merkan-lockup.svg';
import lockupInvers from '../assets/marke/merkan-lockup-inverse.svg';
import lockupPortal from '../assets/marke/merkan-lockup-portal.svg';
import zeichen from '../assets/marke/merkan-mark.svg';
import zeichenInvers from '../assets/marke/merkan-mark-inverse.svg';
import favicon from '../assets/marke/merkan-favicon.svg';
import '../design/marke.css';

type Art = 'lockup' | 'zeichen' | 'portal';
const SEITENVERHAELTNIS: Record<Art, number> = { lockup: 498 / 112, zeichen: 1, portal: 1137 / 112 };

/** Logo in fester Höhe. Unter 24 px Höhe wird für das Zeichen die Favicon-Fassung verwendet. */
export function Logo({ art = 'lockup', hoehe = 24, className }: { art?: Art; hoehe?: number; className?: string }) {
  const breite = Math.round(hoehe * SEITENVERHAELTNIS[art]);
  const hell = art === 'zeichen' ? (hoehe < 24 ? favicon : zeichen) : art === 'portal' ? lockupPortal : lockup;
  // Portal-Lockup gibt es nur hell (offener Punkt: inverse Fassung für das Kundenportal im Dunkelmodus)
  const dunkel = art === 'zeichen' ? (hoehe < 24 ? favicon : zeichenInvers) : art === 'portal' ? lockupPortal : lockupInvers;
  return (
    <span className={`logo logo-${art}${className ? ` ${className}` : ''}`} style={{ width: breite, height: hoehe }}>
      <img className="logo-hell" src={hell} width={breite} height={hoehe} alt="Merkan" draggable={false} />
      <img className="logo-dunkel" src={dunkel} width={breite} height={hoehe} alt="Merkan" draggable={false} aria-hidden="true" />
    </span>
  );
}
